import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import axios from 'axios';

const mockCreds = [
    { username: 'student@example.com', password: 'P@ssw0rd!2025', name: 'ראשית - מנהל לדוגמא' }
];

export default function Office365() {
    const [creds, setCreds] = useState(mockCreds);
    const [copied, setCopied] = useState(null); // key as `${index}-user` or `${index}-pass`
    const [showPassword, setShowPassword] = useState({});
    const [lastViewed, setLastViewed] = useState({});

    useEffect(() => {
        let mounted = true;
        axios.post('/api/get365')
            .then(res => {
                if (!mounted) return;
                try {
                    if (res.data && res.data.msg === 'ok' && res.data.data) {
                        const data = res.data.data;
                        let mapped = [];

                        if (Array.isArray(data)) {
                            // Single row with comma-separated fields
                            if (data.length === 1 && (typeof data[0].user365 === 'string' || typeof data[0].pass365 === 'string')) {
                                const row = data[0];
                                const names = (row.Principal || '').split(',').map(s => s.trim()).filter(Boolean);
                                const users = (row.user365 || '').split(',').map(s => s.trim()).filter(Boolean);
                                const passes = (row.pass365 || '').split(',').map(s => s.trim()).filter(Boolean);
                                const views = (row.passview || '').split(',').map(s => s.trim()).filter(Boolean);
                                const max = Math.max(users.length, passes.length);
                                for (let i = 0; i < max; i++) {
                                    mapped.push({ 
                                        username: users[i] ?? '', 
                                        password: passes[i] ?? '', 
                                        name: names[i] ?? '',
                                        lastView: views[i] ?? ''
                                    });
                                }
                            } else {
                                // Multiple rows: map each row to a credential
                                mapped = data.map(r => ({ username: r.user365 ?? '', password: r.pass365 ?? '', name: r.Principal ?? '' }));
                            }
                        } else if (typeof data === 'object') {
                            // Single object with comma-separated fields
                            const row = data;
                            const names = (row.Principal || '').split(',').map(s => s.trim()).filter(Boolean);
                            const users = (row.user365 || '').split(',').map(s => s.trim()).filter(Boolean);
                            const passes = (row.pass365 || '').split(',').map(s => s.trim()).filter(Boolean);
                            const views = (row.passview || '').split(',').map(s => s.trim()).filter(Boolean);
                            const max = Math.max(users.length, passes.length);
                            for (let i = 0; i < max; i++) {
                                mapped.push({ 
                                    username: users[i] ?? '', 
                                    password: passes[i] ?? '', 
                                    name: names[i] ?? '',
                                    lastView: views[i] ?? ''
                                });
                            }
                        }

                        if (mapped.length > 0) setCreds(mapped);
                    }
                } catch (err) {
                    console.error('Error parsing /api/get365 response', err);
                }
            })
            .catch(() => {
                // keep mock
            });
        return () => { mounted = false };
    }, []);

    const copy = async (text, key) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(key);
            setTimeout(() => setCopied(null), 1500);
        } catch {
            setCopied('err');
            setTimeout(() => setCopied(null), 1500);
        }
    };

    // Use YouTube embed URL (or youtube-nocookie) to avoid X-Frame-Options issues.
    const youtubeId = '0cIZ7mKwNr4'; // change this to the preferred video id
    const youtubeSrc = `https://www.youtube-nocookie.com/embed/${youtubeId}`;
    return (
        <Container style={{ maxWidth: 960, marginTop: 24, direction: 'rtl', textAlign: 'right' }}>
            <h2 className="mb-3">Microsoft 365 — גישה והתחלה מהירה</h2>

            {creds.map((c, idx) => (
                <Card className="mb-3 shadow-sm" key={idx}>
                    <Card.Body>
                        <Row className="align-items-center">
                            <Col md={8}>
                                <h5>{c.name ? `חשבון שייך ל: ${c.name}` : 'פרטי כניסה המופקים על ידי המערכת'}</h5>
                                <hr />
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <div>
                                        <div className="text-muted small">שם משתמש</div>
                                        <div dir="ltr" style={{ fontWeight: 600 }}>{c.username ?? '—'}</div>
                                    </div>
                                    <div>
                                        <Button variant={copied === `${idx}-user` ? 'success' : 'primary'} onClick={() => copy(c.username || '', `${idx}-user`)}>
                                            {copied === `${idx}-user` ? 'הועתק' : 'העתק'}
                                        </Button>
                                    </div>
                                </div>

                                <div>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <div className="text-muted small">סיסמה</div>
                                            <div style={{ fontWeight: 600 }}>{(showPassword[idx]) ? (c.password ?? '—') : (c.password ? '•'.repeat(Math.max(6, c.password.length)) : '—')}</div>
                                        </div>
                                        <div className="d-flex gap-2">
                                            <Button variant="info" onClick={() => {
                                                if (!showPassword[idx]) {
                                                    // Update view time in DB when showing password
                                                    axios.post('/api/updatepassview365', { index: idx })
                                                        .then(res => {
                                                            if (res.data && res.data.msg === 'ok' && res.data.lastView) {
                                                                // Update the creds array with the new lastView time
                                                                setCreds(currentCreds => currentCreds.map((cred, i) => 
                                                                    i === idx ? { ...cred, lastView: res.data.lastView } : cred
                                                                ));
                                                            }
                                                        })
                                                        .catch(console.error);
                                                }
                                                setShowPassword(s => ({ ...s, [idx]: !s[idx] }));
                                            }}>{showPassword[idx] ? 'הסתר' : 'הצג'}</Button>
                                            <Button 
                                                variant={copied === `${idx}-pass` ? 'success' : 'primary'} 
                                                onClick={async () => {
                                                    // First copy the password
                                                    await copy(c.password || '', `${idx}-pass`);
                                                    
                                                    // Then update the view time
                                                    axios.post('/api/updatepassview365', { index: idx })
                                                        .then(res => {
                                                            if (res.data && res.data.msg === 'ok' && res.data.lastView) {
                                                                setCreds(currentCreds => currentCreds.map((cred, i) => 
                                                                    i === idx ? { ...cred, lastView: res.data.lastView } : cred
                                                                ));
                                                            }
                                                        })
                                                        .catch(console.error);
                                                }}
                                            >
                                                {copied === `${idx}-pass` ? 'הועתקה' : 'העתק'}
                                            </Button>
                                        </div>
                                    </div>
                                    <div className="text-muted small mt-2" style={{ fontSize: '0.85em' }}>
                                        {c.lastView ? `הסיסמה הוצגה ב-${c.lastView}` : 'הסיסמה עוד לא הוצגה'}
                                    </div>
                                </div>
                            </Col>
                            <Col md={4} className="text-end">
                                <img src="/utils/icon.png" alt="Office" style={{ width: 96, opacity: 0.9 }} />
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            ))}
            <Card className="mb-3 shadow-sm">
                <Card.Body>
                    <h5>שימוש ב outlook אונליין</h5>
                    <ol>
                        <li>גשו אל <a href="https://share.google/te2mQIMPFkCKfHXta" target="_blank" rel="noreferrer">Outlook</a></li>
                        <li>הזן את שם המשתמש (תיבת המייל) והסיסמה שקיבלת</li>
                    </ol>
                </Card.Body>
            </Card>
            <Card className="mb-3 shadow-sm">
                <Card.Body>
                    <h5>שימוש באפליקציית Outlook</h5>
                    <ol>
                        <li>תיכנסו לאפליקציה</li>
                        <li>ליחצו על הוסף חשבון (מתחת למועדפים ומתחת למייל שלכם)</li>
                        <li>אם לא מצאתם אז בתוכנה לחצו על קובץ> הגדרות> חשבונות> הוסף חשבון</li>
                        <li>הזן את שם המשתמש (תיבת המייל) והסיסמה שקיבלת</li>
                    </ol>
                </Card.Body>
            </Card>
            <Card className="mb-3 shadow-sm">
                <Card.Body>
                    <h5>כיצד להוריד Microsoft 365</h5>
                    <h6>הורדה והתקנה של חבילת אופיס (וורד, אקסל, פאורפוינט) למעוניינים בהתקנה</h6>
                    <ol>
                        <li>גשו אל <a href="https://portal.office.com" target="_blank" rel="noreferrer">Microsoft 365</a></li>
                        <li>התחברו עם שם המשתמש והסיסמה המסופקים.</li>
                        <li>בעמוד החשבון בחרו "Apps" ולחצו על "Install Apps".</li>
                        <li>לאחר ההתקנה, התחברו באפליקציות Office עם אותו חשבון כדי להפעיל את הרישיון.</li>
                    </ol>
                    <div className="mt-3 text-muted small">
                        מסתבך? לפני פניה למוקד
                        <a href="https://chat.openai.com/?model=gpt-5&prompt=אני+מנסה+להוריד+ולהתקין+Office365+חינוכי+A3+ונתקל+בבעיות+בהורדה+או+בהתקנה.+שאל+אותי+שאלות+מנחות+להבין+מהי+הבעיה+ותציע+לי+פתרון.&oq=אני+מנסה+להוריד+ולהתקין+Office365+חינוכי+A3+ונתקל+בבעיות+בהורדה+או+בהתקנה.+שאל+אותי+שאלות+מנחות+להבין+מהי+הבעיה+ותציע+לי+פתרון. " target='_blank'> לחץ כאן </a>

                        מייד לאחר מכן לחץ על
                        <img src="/utils/submit.png" alt="OpenAI" style={{ width: 38, marginLeft: 4, marginRight: 4 }} />
                        <br />
                        אם הבעיה נמשכת — פנו למוקד התמיכה של רשת המעיין (באמצעות חברת טאצ') בדוא"ל: <a href="mailto:support@bney.org.il">support@bney.org.il</a>
                    </div>
                </Card.Body>
            </Card>

            <Card className="mb-5 shadow-sm" style={{ overflow: 'hidden' }}>
                <Card.Body style={{ paddingBottom: '0.5rem' }}>
                    <h5>וידאו מהיר: עבודה עם Microsoft 365</h5>
                    <div style={{ position: 'relative', paddingTop: '56.25%', borderRadius: 8, overflow: 'hidden' }}>
                        <iframe
                            title="Microsoft 365 tutorial"
                            src={youtubeSrc}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
                        />
                    </div>
                </Card.Body>
            </Card>
        </Container>
    );
}
